import { isValidCNPJ } from "@brazilian-utils/brazilian-utils";

import { normalizeDocumentNumber } from "../NormalizeDocumentNumber";

/**
 * Valida CNPJ numérico ou alfanumérico (IN 2229/2024).
 * Utiliza brazilian-utils com version: 2 para suporte alfanumérico.
 */
export function ValidateCNPJ(cnpjInput: string): boolean {
  const cnpj = normalizeDocumentNumber(cnpjInput);

  if (!cnpj || cnpj.length !== 14) return false;

  return isValidCNPJ(cnpj, { version: 2 });
}
